module.exports = __webpack_public_path__ + "img/pr-17.6ad24363.png";